import { SystemStyleObject, chakra } from "@chakra-ui/react";

// Define styles for various parts of the TableComponent
export const StyledTableWrapper = chakra("div", {
  base: {
    width: "100%",
    gap: "5",
  },
});

export const StyledTableHeader = chakra("thead", {
  base: {
    backgroundColor: "#F9FAFB",
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: 500,
    color: "#4A5564",
    textAlign: "left",
  },
});

export const StyledTableRow = chakra("tr", {
  base: {
    border: "transparent!",
  },
});

export const StyledTableHeaderCell = chakra("th", {
  base: {
    // padding: "8px",
    // borderTop: "1px solid #EAECF0!",
    borderBottom: "1px solid #EAECF0!",
    padding: "13px 24px",
    textAlign: "left",
    fontWeight: 500,
  },
});

export const StyledTableCell = chakra("td", {
  base: {
    paddingX: "24px",
    paddingY: "27px",
    backgroundColor: "#FFFFFF",
    borderBottom: "1px solid #EAECF0!",
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "normal",
    color: "#4A5564",
    textAlign: "left",
  },
});

export const firstColumnCheckboxWrapperCss: SystemStyleObject = {
  display: "flex",
  alignItems: "center",
  position: "absolute",
  left: "12px",
  top: "50%",
  transform: "translateY(-50%)",
};

export const tableHeaderCtaCss: SystemStyleObject = {
  boxShadow: "0px 0px 0px 1px #122B6914",
  padding: "8px 16px",
  borderRadius: "8px",
  gap: "8px",
  display: "flex",
  alignItems: "center",
  height: "36px",
};
